export default __webpack_public_path__ + "static/media/0xfad65eb62a97ff5ed91b23afd039956aaca6e93b.cf5fa103.webp";